module.exports = __webpack_public_path__ + "media/images/ui__textArrowLeft-ed855e674af7b02706d726362698a07c.png";